import { PageexpiredHolder, Pageexpiredcontent } from "./style";
import { useTrialInfo } from "../hooks/useTrialInfo";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";

export const TrialExpired = () => {
  const { workspaceId } = useParams();
  const navigate = useNavigate();
  const { isTrialExpired } = useTrialInfo(workspaceId);

  useEffect(() => {
    if (!isTrialExpired) {
      navigate(`/workspace/${workspaceId}/home`);
    }
  }, [isTrialExpired, navigate, workspaceId]);

  return (
    <PageexpiredHolder>
      <Pageexpiredcontent>
        <h2>Trial Expired</h2>
        <p>
          {" "}
          Your free trial has ended. To continue using Brighthive and regain
          access to your workspace, please contact our team to purchase a
          subscription.
        </p>
        <p>
          All features are currently disabled, but your data and settings are
          safely preserved. Once you upgrade, you’ll be able to pick up right
          where you left off.
        </p>
        <p>
          Ready to continue?
          <a href="mailto:support@brighthive.io">
            {" "}
            Contact Brighthive Support
          </a>{" "}
          to discuss your options and unlock full access.
        </p>
        <p>Thank you for trying Brighthive!</p>
      </Pageexpiredcontent>
    </PageexpiredHolder>
  );
};
